module.exports = __webpack_public_path__ + "img/note_icon.87327f7f.svg";